import apiAction from 'common/actions/api'

export const SET_FILTERS = 'cylera/settings/roles/default/SET_FILTERS'
export const CLEAR_ROLES = 'cylera/settings/roles/default/CLEAR_DASHBOARDS'

const rolesApi = apiAction('role')

export function clearRoles(callback) {
  return dispatch => {
    dispatch({
      type: CLEAR_ROLES
    })
  }
}

export const getRolesCount = filterValues =>
  rolesApi(
    'count',
    { role_type: 'Default', ...filterValues },
    { cacheable: false }
  )

export const getRoles = (
  page,
  pageSize,
  sortKey,
  sortDirection,
  filterValues,
  { infinite = false } = {}
) => {
  const { query } = filterValues || {}
  return rolesApi(
    'list',
    {
      page,
      page_size: pageSize,
      sort_key: sortKey,
      sort_direction: sortDirection,
      query,
      role_type: 'Default'
    },
    { infinite, cacheable: false }
  )
}

export function setFilters(filters) {
  return dispatch => {
    dispatch({
      type: SET_FILTERS,
      data: {
        filters
      }
    })
  }
}
